module.exports = __webpack_public_path__ + "static/media/kitchen.1379507c.svg";